import { SignalingGetLogResponse } from "../../proto/SignalingGetLog_pb";

export const SET_SIGNALING_LOG_LIST = "SET_SIGNALING_LOG_LIST";

export type SignalingLogListType = SignalingGetLogResponse.AsObject["signalingLogList"];

export type SignalingLogListStateType = {
  signalingLogList: SignalingLogListType;
};

export type SetSignalingLogListActionType = {
  type: typeof SET_SIGNALING_LOG_LIST;
  payload: SignalingLogListType;
};

export type SignalingLogListActionTypes = SetSignalingLogListActionType;
